<template>
  <fts-client-modal 
    :title="`Send invitations to ${formData.workspaceName || 'Inistate'}`"
    :description="`New members will be able to see all of ${formData.workspaceName || 'Inistate'}'s modules that have been shared in the workspace.`"
    ref="ftsClientModal"
  >
    <!-- header:icon -->
    <font-awesome-icon slot="icon" :icon="['fas', 'user-plus']" fixed-width />
    <!-- body -->
    <template #body>
      <fts-invitation @close="close" ref="ftsInvitation" />
    </template>
  </fts-client-modal>
</template>

<script>
import FTSClientModal from "../elements/FTSClientModal";
import FTSInvitation from "./FTSInvitation";

export default {
  components: {
    "fts-client-modal": FTSClientModal,
    "fts-invitation": FTSInvitation
  },
  data: () => ({
    formData: {}
  }),
  methods: {
    open(item) {
      this.formData = _.cloneDeep(item);
      this.$refs.ftsClientModal.show();
      this.$nextTick(() => {
        this.$refs.ftsInvitation.focus();
      });
    },
    close() {
      this.$refs.ftsClientModal.close();
    }
  }
}
</script>